import { NotificationType } from '@/features/notifications/notification-service-extension-shared/constants/firebase'
import { NotificationSoundPreferences } from '@/features/settings/types'

export const defaultSoundPreferences: NotificationSoundPreferences = {
    [NotificationType.AcceptedOrder]: true,
    [NotificationType.AwaitingAcceptanceOrder]: true,
}
